module.exports = __webpack_public_path__ + "static/img/slogan.0f2e70d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/slogan.png
// module id = sdUw
// module chunks = 0